<template>
  <v-form
    lazy-validation
    @submit.prevent="next"
  >
    <v-layout
      row
      class="separatorNotice"
    > 
      <h2 class="font-weight-regular white--text separatorTittle">
        Datos generales
      </h2>
    </v-layout> 
    <v-layout
      wrap
      row
      justify-center
    >
      <v-flex
        x6
        sm6
      >
        <v-flex xs12>
          <v-form
            lazy-validation
            @submit.prevent="submit"
          >
            <v-layout
              wrap
              justify-space-around
              fill-height
              align-center
            >
              <v-flex
                xs12
                sm12
              >
                <v-text-field
                  label="Título"
                  v-model="v.title.$model"
                  outline
                  :error-messages="titleErrors"
                  style=" margin-top: 25px;"
                />
              </v-flex>
              <v-flex
                xs12
                sm12
              >
                <v-textarea
                  id="descriptionField"
                  outline
                  label="Descripción"
                  placeholder="Recuerda añadir en este espacio toda la información del comunicado, como objetivo del comunicado, lugar, horario, etc."
                  v-model="v.description.$model"
                  :error-messages="descriptionErrors"
                  rows="5"
                />
              </v-flex>
            </v-layout>
          </v-form>
          <v-form
            d-flex
            class="justify-center align-center"
          >
            <span class="labelTip">Selecciona la fecha de visibilidad que tendrá el comunicado</span>
            <!------------------------------  NEW DATE TIME PICKERS  ---------------------------------->
            <v-layout>
              <VueTimePickerTool
                :error-messages="dateStartErrors"
                title-date="Fecha de inicio comunicado"
                title-time="Hora de inicio"
                v-model="v.startDate.$model"
                location="up"
                style="margin-top:20px;"
                :min="today"
                :hour="hour"
              />
            </v-layout>
            <v-layout>
              <VueTimePickerTool
                :error-messages="dateEndErrors"
                :disabledV="getDisabledEndDate"
                tooltip="Es necesario seleccionar primero la fecha de incio"
                title-date="Fecha de término comunicado"
                title-time="Hora de inicio"
                v-model="v.endDate.$model"
                location="up"
                :min="getMinDate"
              />
            </v-layout>
          </v-form>
          <!------------------------------  TOOLTIPS  ---------------------------------->
          <v-layout
            wrap
            justify-space-around
            fill-height
            right
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  color="black"
                  v-on="on"
                >
                  help
                </v-icon>
              </template>
              <span>Establece los datos generales del comunicado</span>
            </v-tooltip>
          </v-layout>
          <!-------------------------------  IMAGEN PORTADA  ---------------------------------->
          <v-layout
            style="margin: 10px"
          >
            <NoticeImage v-model="v.imageStorage.$model" />
          </v-layout>
        </v-flex>
      </v-flex>
      <v-flex
        xs6
        sm6
        shrink
      />
    </v-layout>

    <v-layout
      row
      class="separatorNotice"
    > 
      <h2 class="font-weight-regular white--text separatorTittle">
        Multimedia
      </h2>
    </v-layout> 
    
    <v-layout>
      <v-flex
        xs12
        sm6
        md6
      >
        <NoticePDF
          :notice="noticeForm"
          v-model="v.files.$model"
        />
      </v-flex>
    </v-layout>

    <v-layout
      row
      class="separatorNotice"
    > 
      <h2 class="font-weight-regular white--text separatorTittle">
        Acerca del comunicado
      </h2>
    </v-layout> 
    <v-layout
      wrap
      row
    >
      <v-flex
        xs12
        sm6
        md6
      >
        <type-statement-selector
          :v="v"
          :type="v.type.$model"
          :assistanceRequired="v.assistanceRequired.$model"
          :attendanceStudentRequired="v.attendanceStudentRequired.$model"
          :confirmParent="v.confirmParent.$model"
          :startEventDate="v.startEventDate.$model"
          :startDate="v.startDate.$model"
          :endDate="v.endDate.$model"
          :errorMessage="startEventErrors"
          @type-selected="cambiaTipo"
          @confirm-parent-change="confirmParentChange"
          @assistence-requiered-change="assistenceRequieredChange"
          @attendance-student-required-change="attendanceStudentRequiredChange"
          @start-event-date-change="startEventDateChange"
        />
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import VueTimePickerTool from "../Notices/Tools/VueDateTimePicker2";

import NoticeImage from "../../Sections/Notices/NoticesImage3";
import NoticePDF from "../../Sections/Notices/NoticePDF3";
import TypeStatementSelector from "../../Tools/TypeStatementSelector.vue"

// CSS
import 'vue2-timepicker/dist/VueTimepicker.css';



export default {
  props: ["value", "v", "clear"],
  components: {
    NoticeImage,
    NoticePDF,
    VueTimePickerTool,
    TypeStatementSelector
  },
  data: () => ({
    type: "A",
    today: "",
    hour:"",
    menu: {
      startD: false,
      startT: false,
      endD: false,
      endT: false
    },
    noticeForm: {
      imgs: [],
      files: [],
    },
    
    styleObjectA: 'primary',
    styleObjectE: 'outline'
  }),
  watch: {
    value() {
      this.type = this.value;
      this.noticeForm = {
      imgs: [],
      files: [],
      };
    },
    clear() {
      if(this.clear){
        this.v.startDate.$reset()
        this.v.endDate.$reset()
        this.v.startEventDate.$reset()
      }
    }
    
  },
  mounted() {
    this.today = new Date().toLocaleDateString("sv-SE"); 
    this.hour = new Date().toLocaleTimeString("sv-SE",{hour: '2-digit', minute:'2-digit'});
    console.log(this.today + " " + this.hour);
   
  },
  computed: {
    // errores para los campos de titulo y descripción
    titleErrors() {
				const errors = [];
				if (!this.v.title.$dirty) return errors;
				!this.v.title.required && errors.push("Título requerido");
				return errors;
		},
		descriptionErrors() {
				const errors = [];
				if (!this.v.description.$dirty) return errors;
				!this.v.description.required && errors.push("Descripción requerida");
				return errors;
		},
    // errores para los inputs de fecha
    dateStartErrors() {
      const errors = [];
      if (!this.v.startDate.$dirty) return errors;
      !this.v.startDate.required && errors.push("Fecha de inicio obligatoria");
      return errors;
    },
    dateEndErrors() {
      const errors = [];
      if (!this.v.endDate.$dirty) return errors;
      !this.v.endDate.validateDateEnd &&
        errors.push("La fecha final debe ser mayor a la de inicio");
      !this.v.endDate.required && 
        errors.push("Fecha final obligatoria");
      return errors;
    },
    startEventErrors() {
      const errors = [];
      if (!this.v){
        return errors
      }
      if(this.v.type.$model === "A"){ return errors }
      if (!this.v.startEventDate.$dirty) return errors;
      !this.v.startEventDate.validateDateStartEvent &&
        errors.push("La fecha de inicio del evento debe ser mayor o igual a la fecha de inicio de visibilidad y menor a la fecha final de visibilidad");
      !this.v.startEventDate.required &&
        errors.push("La fecha de inicio de evento es obligatoria");
      return errors;
    },
    getMinDate(){
        if(this.v.startDate.$model){
          const date = new Date(this.v.startDate.$model).toLocaleDateString("sv-SE"); 
          return date
        }
        return ""
    },
    getDisabledEndDate(){
      if(!this.v.startDate.$model){
        return true
      }
      return false
    }
  },
  methods:{
    confirmParentChange(event){
      this.v.confirmParent.$model = event
    },
    assistenceRequieredChange(event){
      this.v.assistanceRequired.$model = event
    },
    attendanceStudentRequiredChange(event){
      this.v.attendanceStudentRequired.$model = event
    },
    startEventDateChange(event){
      this.v.startEventDate.$model = event
    },
    cambiaTipo(e){
      this.v.type.$model=e;
    }
  }
};
</script>

<style>
.labelTip3{
	color: rgba(115, 115, 115, 0.87);
  font-size: 1em;
  margin-top: 50px;
  
}
</style>
